import { Button } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import styles from "../assets/css/style.module.scss";
import eyeOff from "../assets/img/signupv2/willow/eye-off.svg";
import eyeOn from "../assets/img/signupv2/willow/eye-on.svg";
import { Skeleton } from "@mui/material";
import { passwordReset, verifyPasswordReset } from "../services/auth";
import { useSearchParams } from "react-router-dom";
import {
  willow_signup_downloaded,
  willow_signup_landed,
  willow_signup_completed,
  setClevertapProfile,
  willow_cancel_successful,
  willow_cancel_downloaded,
  willow_cancel_landed,
} from "../libs/events";
import TcQR from "../assets/img/tc_qr.svg";
import device from "../assets/img/signupv2/willow/device.svg";
import WillowRightSection from "../components/WillowRightSection";
import giftbagIcon from "../assets/img/giftbag.svg";
import { countdown } from "../libs/utils";

function WillowSignup() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const token = searchParams.get("token");
  const action_type = searchParams.get("action_type");
  const flow = searchParams.get("flow");

  const [showPassword, setShwoPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [onSuccess, setOnSuccess] = useState(false);
  const [plan, setPlan] = useState(null);
  const [appLinkToken, setAppLinkToken] = useState();

  const countdownRef = useRef();

  useEffect(() => {
    countdown(1800, countdownRef);
  }, []);

  const changePassword = (e) => {
    e.preventDefault();
    setError(null);
    if (
      !/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&<>*~:`-]).{8,20}$/.test(
        password
      )
    ) {
      setError(
        "Password should be minimum 8 characters long, it should have at least 1 uppercase, 1 number and 1 symbol."
      );
    } else {
      passwordReset({
        id: id,
        token: token,
        action_type: action_type,
        password: password,
      })
        .then((response) => {
          if (flow === "CANCELLATION") {
            willow_cancel_successful({
              email,
              plan,
            });
          } else {
            willow_signup_completed({
              email,
              plan,
            });
          }
          setAppLinkToken(response.app_link_token);
          setOnSuccess(true);
        })
        .catch((error) => {
          setError(
            error?.response?.data?.error?.message
              ? error?.response?.data?.error?.message
              : error.message
          );
        });
    }
  };

  // const handleClose = () => {
  //   console.log("close");
  // };

  const handleDownload = (platform) => {
    if (platform === "ios") {
      if (flow === "CANCELLATION") {
        willow_cancel_downloaded({ platform_selected: "ios" });
      } else {
        willow_signup_downloaded({ platform_selected: "ios" });
      }

      window.open("https://ddl.timesclub.co/Iiw9/b3gb5jtw");
    } else if (platform === "android") {
      if (flow === "CANCELLATION") {
        willow_cancel_downloaded({ platform_selected: "android" });
      } else {
        willow_signup_downloaded({ platform_selected: "android" });
      }

      window.open("https://ddl.timesclub.co/Iiw9/fk0p2206");
    }
  };

  useEffect(() => {
    verifyPasswordReset({
      id: id,
      token: token,
      action_type: action_type,
    })
      .then((response) => {
        setClevertapProfile({ email: response.email });
        setEmail(response.email);
        setPlan(response.subscription_plan);
        if (flow === "CANCELLATION") {
          willow_cancel_landed({
            email: response.email,
            plan: response.subscription_plan,
          });
        } else {
          willow_signup_landed({
            email: response.email,
            plan: response.subscription_plan,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.data?.error?.message == 0) {
          setError("Oops! Something went wrong");
        } else {
          setError(
            error?.response?.data?.error?.message
              ? error?.response?.data?.error?.message
              : error.message
          );
        }
      });
  }, []);

  return (
    <div className={styles.willow}>
      <div className={styles.container}>
        <div className={styles.signupBox}>
          {/* <div className={styles.closeBox} onClick={handleClose}>
            <img src={close} />
          </div> */}
          <div className={styles.body}>
            <div className={`${styles.itemLeft} ${styles.screen1}`}>
              {onSuccess ? (
                <>
                  <div className={styles.screen2}>
                    <div className={styles.success}>Success</div>
                    <div className={styles.title}>Your account is ready.</div>
                    <div className={styles.subTitle}>
                      To access your cashback credited to your Abound account,
                      please{" "}
                      <span className={styles.loginText}>
                        login to the Abound app using your email and password.
                      </span>
                    </div>
                    <div className={styles.text2}>
                      Get the app now to claim your cashback and an{" "}
                      <span className={styles.someText}>
                        additional $5 welcome bonus.
                      </span>
                    </div>
                    <div
                      className={`${styles.countdownContainer} ${styles.bottomSpace}`}
                    >
                      <div className={styles.cdLeftSection}>
                        <img src={giftbagIcon} />
                        $5 welcome bonus
                      </div>
                      <div>
                        Claim in <span ref={countdownRef}>29m 36s</span>
                      </div>
                    </div>
                    <div className={styles.bottomContainer}>
                      <div className={styles.bottomBox}>
                        <div className={styles.device}>
                          <img src={device} />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.itemLeftContent}>
                    <div className={styles.title}>Claim your cashback!</div>
                    <div className={styles.subTitle}>
                      Your Abound account has been created. Please set a
                      password to claim your cashback.
                    </div>
                    <div className={styles.email}>
                      {email ? (
                        email
                      ) : (
                        <>
                          {!error && (
                            <Skeleton
                              width={210}
                              sx={{ bgcolor: "grey.700" }}
                            />
                          )}
                        </>
                      )}
                    </div>
                    <div className={styles.inputLabel}>Create a Password</div>
                    <form onSubmit={changePassword}>
                      <div className={styles.inputControl}>
                        <input
                          autoFocus={true}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="New Password"
                          type={showPassword ? "text" : "password"}
                          className={styles.pl15}
                        />
                        <div
                          className={styles.passwordEye}
                          onClick={() => setShwoPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <img src={eyeOn} />
                          ) : (
                            <img src={eyeOff} />
                          )}
                        </div>
                      </div>
                      <div
                        className={styles[error ? "inputError" : "inputInfo"]}
                      >
                        {error
                          ? error
                          : "Password must be at least 8 characters."}
                      </div>
                      {email ? (
                        <Button type="submit" className={styles.btnGolden}>
                          Next
                        </Button>
                      ) : (
                        <>
                          <Button className={styles.btnGoldenDisabled}>
                            Next
                          </Button>
                        </>
                      )}
                    </form>
                  </div>
                  <div className={styles.terms}>
                    By clicking on Next button, you agree to{" "}
                    <a target="_blank" href="/terms-conditions">
                      <span className={styles.termsLink}>Abound terms</span>
                    </a>{" "}
                    and{" "}
                    <a target="_blank" href="/privacy">
                      <span className={styles.termsLink}>privacy policy</span>
                    </a>
                    .
                  </div>
                </>
              )}
            </div>
            <div className={styles.itemRight}>
              <WillowRightSection
                screen={onSuccess ? 2 : 1}
                appLinkToken={appLinkToken}
                id={id}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WillowSignup;
